module.exports = __webpack_public_path__ + "957a1f0804d39fd73b4aa963e37fc6d2.png";